/**
 * Meta AI journey — protocol `discovery-only` (ADR-0159 §3).
 *
 * Live discovery reads → terminal "reads, cites, leaves — no checkout to
 * authorize" phase INSIDE `PhaseTimeline` (founder decision — a terminal
 * phase, not a footer card). The journey completes without a mandate,
 * cart, or payment.
 */

import { buildDiscoveryOnlyTerminalPhase } from './discovery-only-terminal.js';
import { buildDiscoveryPhase, buildReadMenuPhase } from './discovery.js';
import type { JourneyContext, Phase } from './types.js';

export function buildMetaJourney(ctx: JourneyContext): Phase[] {
  const { agent, live, installed, cardUrl, catalogUrl, liveProducts } = ctx;
  return [
    buildDiscoveryPhase(agent, installed, cardUrl, live.card),
    buildReadMenuPhase(agent, installed, catalogUrl, live.catalog, liveProducts),
    buildDiscoveryOnlyTerminalPhase(agent),
  ];
}
